import { toMomentFromUtc } from 'api/helpers';

export default class OrderDetails {
	type = null;
	date = null;
	franchisee_number = null;
	po_number = null;
	totals = {
		list: null,
		net: null,
	};
	count = null;

	constructor(details) {
		this.type = details.OrderType;
		this.date = toMomentFromUtc(details.OrderDate);
		this.franchisee_number = details.FranchiseeNumber;
		this.po_number = details.PoNumber;
		this.totals = {
			list: details.TotalOrderList,
			net: details.TotalOrderNet,
		};
		this.count = details.ItemCount;
	}
}



// WEBPACK FOOTER //
// ./src/api/models/OrderDetails.js